import { useQuery } from '@tanstack/react-query';
import { runRecallQuery, type RecallParams } from './api';

export const recallKeys = {
  all: ['recall'] as const,
  query: (p: RecallParams) => [...recallKeys.all, p] as const,
};

/** Runs when a scope value is set. A POST that only reads, so it's a query (cached, URL-driven). */
export function useRecallQuery(params: RecallParams | null) {
  return useQuery({
    queryKey: recallKeys.query(params ?? { by: 'listingId', value: '' }),
    queryFn: () => runRecallQuery(params!),
    enabled: !!params && params.value.trim().length > 0,
    meta: { silent: true },
  });
}
